const testimonials = [
  {
    name: "Jessica M.",
    location: "Carrollton, GA",
    rating: 5,
    text: "My son's school trip to France was in 10 days and we realized his passport had expired. Fast Passport Center got him an expedited passport in under a week. They answered every question I had and kept me calm the whole time.",
    service: "Child Passport",
  },
  {
    name: "Robert K.",
    location: "Villa Rica, GA",
    rating: 5,
    text: "Business trip to London got moved up to 5 days out. I called in a panic from my office in Carrollton. Started online that afternoon, shipped from Carrollton overnight, and had my emergency passport in 4 days. Incredible.",
    service: "Emergency Passport",
  },
  {
    name: "Amanda T.",
    location: "Bremen, GA",
    rating: 5,
    text: "We booked a cruise to the Bahamas and my husband couldn't find his passport anywhere. Fast Passport Center walked us through the replacement process, told us exactly which clerk to visit in Carrollton, and had a new one in hand with time to spare.",
    service: "Lost Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function CarrolltonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What West Georgia Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Carrollton, Villa Rica, Bremen, and west Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}